module.exports = __webpack_public_path__ + "static/media/logo.f7bd6cfe.png";